/**
 * Prizes of the Fun Arcade claw machine. They reuse the Sorting House GPT
 * items, so a teddy looks the same in every house. Wish prizes are the
 * plush friends a child marked with a gold ticket; the rest fill the glass.
 */
export interface ArcadePrize {
  readonly id: string;
  readonly assetId: string;
  readonly name: string;
}

const prize = (id: string, name: string): ArcadePrize => ({ id, assetId: `item.${id}`, name });

export const ARCADE_PRIZES: readonly ArcadePrize[] = [
  prize("teddy", "Gấu bông"),
  prize("bunny", "Thỏ bông"),
  prize("kitty", "Mèo bông"),
  prize("duck", "Vịt vàng"),
  prize("ball", "Bóng sọc"),
  prize("robot", "Rô bốt"),
  prize("toy-car", "Xe đồ chơi"),
  prize("blocks", "Khối gỗ"),
  prize("top", "Con quay"),
];

/** Friends a wish card can ask for; the other kinds only fill the glass. */
export const ARCADE_WISH_KINDS = ["teddy", "bunny", "kitty"] as const;

/** The beach ball is the only bouncy prize (chapter Bóng nảy). */
export const ARCADE_BOUNCY_KIND = "ball";

export const ARCADE_PRIZE_BY_ID: ReadonlyMap<string, ArcadePrize> = new Map(ARCADE_PRIZES.map((p) => [p.id, p]));

/** Art the claw machine scene needs besides the prizes. */
export const ARCADE_ASSET_IDS = [
  "arcade.claw-open",
  "arcade.claw-closed",
  "arcade.chute",
  "arcade.ticket",
  "arcade.token",
  "arcade.carriage",
  "arcade.marquee",
  "arcade.ribbon",
  "arcade.glass",
  "arcade.weight",
  "reward.sparkle",
] as const;
